"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayContract = void 0;
const contracts_1 = require("@etherspot/contracts");
const internal_contract_1 = require("./internal.contract");
class GatewayContract extends internal_contract_1.InternalContract {
    constructor() {
        super(contracts_1.ContractNames.Gateway);
    }
    hashDelegatedBatch(account, nonce, to, data) {
        return this.hashMessagePayload('DelegatedBatch', [
            { name: 'account', type: 'address' },
            { name: 'nonce', type: 'uint256' },
            { name: 'to', type: 'address[]' },
            { name: 'data', type: 'bytes[]' },
        ], {
            account,
            nonce,
            to,
            data,
        });
    }
}
exports.GatewayContract = GatewayContract;
